import React, { useEffect, useState } from "react";
import HorizontalGridList from "components/HorizontalGridList";
import api from "../api";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ExpandMoreOutlined, RefreshOutlined } from "@mui/icons-material";
import CollapsibleDataTable from "components/CollapsibleDataTable";

const useStyles = makeStyles((theme) => ({
  insideMainAccordian: {
    width: "100%",
  },
  button: {},
}));

const Logs = () => {
  const classes = useStyles();

  // Sources and Current Source index
  const [subLink, setSubLink] = useState(-1);
  const [sources, setSources] = useState([]);
  const [fieldDetails, setFieldDetails] = useState(null);

  // Add jobs for current source
  const [allJobs, setAllJobs] = useState([]);
  //Refresh Button
  const [refresh, setRefresh] = useState(true);
  const [openRows, setOpenRows] = useState({});

  // On Did Mount
  useEffect(() => {
    api
      .getPullSources()
      .then((data) => {
        setSources(data);
        setSubLink(0);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    // FETCH NEW META DATA FOR SOURCE
    setFieldDetails(null);
    setOpenRows({
      pull: {},
      enrichment: {},
      transfer: {},
    });

    if (subLink >= 0) {
      // GET META DATA FOR CURRENT DATA SOURCE
      api
        .meta(sources[subLink].key)
        .then((data) => {
          setFieldDetails(data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [sources, subLink]);

  // On Update sources subLink Refresh
  useEffect(() => {
    //Table clears first then updates for new source
    setAllJobs([]);

    if (subLink >= 0) {
      api
        .get_all_jobs("ABCD12345", sources[subLink].key)
        .then((data) => {
          setAllJobs(data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [sources, subLink, refresh]);

  return (
    <>
      {subLink >= 0 && fieldDetails ? (
        <>
          <HorizontalGridList
            subLink={subLink}
            setSubLink={setSubLink}
            sources={sources}
          />
          <h1>{sources[subLink].name}</h1>

          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className={classes.gridRow}
          >
            <p></p>
            <Button
              variant="outlined"
              className={classes.button}
              onClick={() => {
                setRefresh((prevValue) => !prevValue);
              }}
            >
              <RefreshOutlined />
            </Button>
          </Grid>

          {fieldDetails["pull"] && (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreOutlined />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Pull Logs</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.insideMainAccordian}>
                  <CollapsibleDataTable
                    source={sources[subLink]}
                    tableData={allJobs.filter((value) => {
                      return value["type"] === "pulljob";
                    })}
                    innerSet="pulljob_set"
                    outerTableFields={fieldDetails["pull"]["outerTableFields"]}
                    innerTableFields={fieldDetails["pull"]["logFields"]}
                    deleteFunc={api.stop_job}
                    logs
                    type="pull"
                    openRows={openRows}
                    setOpenRows={setOpenRows}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          )}

          {fieldDetails["enrich"] && (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreOutlined />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Enrich Logs</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.insideMainAccordian}>
                  <CollapsibleDataTable
                    source={sources[subLink]}
                    tableData={allJobs.filter((value) => {
                      return value["type"] === "enrichmentjob";
                    })}
                    innerSet="enrichmentjob_set"
                    outerTableFields={
                      fieldDetails["enrich"]["outerTableFields"]
                    }
                    innerTableFields={fieldDetails["enrich"]["logFields"]}
                    deleteFunc={api.stop_job}
                    logs
                    type="enrichment"
                    openRows={openRows}
                    setOpenRows={setOpenRows}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          )}

          {fieldDetails["transfer"] && (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreOutlined />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>Transfer Logs</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.insideMainAccordian}>
                  <CollapsibleDataTable
                    source={sources[subLink]}
                    tableData={allJobs.filter((value) => {
                      return value["type"] === "transferjob";
                    })}
                    innerSet="transferjob_set"
                    outerTableFields={
                      fieldDetails["transfer"]["outerTableFields"]
                    }
                    innerTableFields={fieldDetails["transfer"]["logFields"]}
                    deleteFunc={api.stop_job}
                    logs
                    type="transfer"
                    openRows={openRows}
                    setOpenRows={setOpenRows}
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          )}
        </>
      ) : (
        <h1>Loading</h1>
      )}
    </>
  );
};

export default Logs;
